export default __webpack_public_path__ + "static/halcyon-semibold-78ce0207e6b0899059e6359ce345c7dd.ttf";